import React, { useEffect } from 'react';

export default function Toast({ toast, onDismiss }) {
    useEffect(() => {
        if (!toast) return undefined;
        const timer = setTimeout(onDismiss, 6000);
        return () => clearTimeout(timer);
    }, [toast, onDismiss]);

    if (!toast) return null;

    return (
        <div className={`toast toast-${toast.tone}`} role="status" aria-live="polite">
            <span>{toast.message}</span>
            <button type="button" onClick={onDismiss} aria-label="Meldung schließen">
                ×
            </button>
        </div>
    );
}
